import React from "react";
import { useField } from "formik";
import { FormFieldRow } from "../misc/formFieldRow";
import { ToggleSwitch } from "./formSwitch.styled";

interface FormSwitchRowProps {
    name: string;
    label: string;
    checkLabel?: string;
    hidden?: boolean;
    disabled?: boolean;
}

export const FormSwitchRow = (props: FormSwitchRowProps) => {
    const [field, , helpers] = useField<boolean | undefined>(props.name);
    const checked = field.value ?? false;

    return (
        <FormFieldRow label={props.label} hidden={props.hidden}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <ToggleSwitch
                    type="button"
                    role="switch"
                    aria-checked={checked}
                    aria-label={props.checkLabel ?? props.label}
                    $checked={checked}
                    disabled={props.disabled}
                    onClick={() => helpers.setValue(!checked)}
                />
                {props.checkLabel && <span>{props.checkLabel}</span>}
            </div>
        </FormFieldRow>
    );
};